import { Box, IconButton, Stack } from "@mui/material";
import { PropsWithChildren } from "react";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { Typography } from "@platform/design-system";

type HeaderExtraFormatProps = {
  title: string;
  description: string;
};

export const HeaderExtraFormat: React.FC<HeaderExtraFormatProps> = ({
  title,
  description,
}) => (
  <Stack direction="column" spacing={0.5}>
    <Typography variant="caption" color="textSecondary">
      {title}
    </Typography>
    <Typography variant="body-medium">{description}</Typography>
  </Stack>
);

export const HeaderExtraBackgroundFormat: React.FC<PropsWithChildren> = ({
  children,
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      bgcolor: "background.paper",
      borderRadius: "6px",
      gap: 2,
      px: 2,
      py: 1,
    }}
  >
    {children}
  </Box>
);

type HeaderExtraBrokerSettingsIconProps = {
  navigateToBrokerSettingPage: () => void;
};

export const HeaderExtraBrokerSettingsIcon: React.FC<
  HeaderExtraBrokerSettingsIconProps
> = ({ navigateToBrokerSettingPage }) => (
  <IconButton
    onClick={navigateToBrokerSettingPage}
    aria-label="Broker Settings"
  >
    <SettingsOutlinedIcon />
  </IconButton>
);
